<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-sm" role="document">
			<div class="modal-content">
				<loading :active="loading">
					<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
				</loading>
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4  class="modal-title">Compartir proyecto</h4>
				</div>
				<div class="modal-body">
					<template v-if="item">
						<div class="row">
									<div class="col-md-12">
										<multiselect
											@search-change="search"
											:loading="isLoading"
											v-model="selected_user"
											label="email"
											track-by="id"
											:options="options"
											:multiple="false"
											:placeholder="$t('generals.write_something') + '...'"
											@select="userSelected"
											:internal-search="false">
										</multiselect>
										<br>
										<table class="table table-condensed">
											<tbody>
												<tr v-for="share_user in share_users">
													<td>
														<img v-if="share_user.profile.avatar" :src="share_user.profile.avatar" class="img-circle" width="30px"
														:alt="share_user.email"
														:title="share_user.email">
														<span v-else>
															{{ share_user.email }}
														</span>
													</td>
													<td>
														<span class="pull-right link">
															<button @click="deleteShareUser(share_user)" type="button" class="btn btn-danger btn-sm" name="button">
																<i class="fa fa-trash" aria-hidden="true"></i>
															</button>
														</span>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
					</template>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import VueElementLoading from 'vue-element-loading'
	import Multiselect from 'vue-multiselect'

	export default {
		props: ['user', 'isAuth', 'item'],
		components: {
			'loading': VueElementLoading,
			'multiselect': Multiselect,
		},
		data () {
			return {
				modal: {
					selector: 'modal-share-project'
				},

				loading:  null,
				share_users: null,
				isLoading: false,
				options: [],
				selected_user: null,

				statuses: null,
				statuses_filter: null,
			}
		},
		methods: {
			open() {
				this.getShareUsers()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			reload() {
				this.getShareUsers()
			},
			getShareUsers() {
				this.share_users = null
				this.loading = true
				this.$http.get('admin/projects/projects/' + this.item.id + '/sharing/users')
					.then(response => {
						console.log(response)
						this.loading = false
						this.share_users = response.body
					})
			},
			search(query) {
				if(query) {
					this.isLoading = true
					var data = {
						query: query,
						filter: {
							role_id: 10,
						}
					}

					this.$http.post('admin/users/search', data)
					.then(response => {
						this.isLoading = false
						this.options = response.body
						this.filterUsers()
					}).catch(function(response) {
						this.isLoading = false
						console.log(response)
					})
				}
			},
			filterUsers() {
				if(this.share_users) {
					if(this.share_users.length) {
						if(this.options) {
							if(this.options.length) {
								var that = this
								this.options = this.options.filter(function(option) {
									return that.share_users.find(function(user) {
										return user.id != option.id
									})
								})
							}
						}
					}
				}
			},
			userSelected(user) {
				if(user) {
					this.selected_user = null
					this.storeSharingUser(user)
				}
			},
			storeSharingUser(user) {
				var that = this
				swal.queue([{
					title: 'Compartir proyecto',
					text: 'El proyecto será compartido con ' + user.email,
					type: "info",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.get('admin/projects/projects/' + that.item.id + '/share/user/' + user.id)
							.then(response => {
								that.reload()
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								if(response.status == 409) {
									swal(response.body.title, response.body.text, response.body.type);
								} else {
									swal({
										title: response.statusText,
										text: response.body,
										type: "warning"
									});
								}
							})
						})
					}
				}]).catch(swal.noop)
			},
			deleteShareUser(user) {
				var that = this
				swal.queue([{
					title: 'Dejar de compartir el proyecto',
					text: 'El proyecto se dejará de compartir con ' + user.email,
					type: "info",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/projects/projects/' + that.item.id + '/share/user/' + user.id)
							.then(response => {
								that.reload()
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								if(response.status == 409) {
									swal(response.body.title, response.body.text, response.body.type);
								} else {
									swal({
										title: response.statusText,
										text: response.body,
										type: "warning"
									});
								}
							})
						})
					}
				}]).catch(swal.noop)
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/projects/views/Share.vue